import React from 'react';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import { useTranslation } from 'react-i18next';

import { getDeploymentDateTime, xlsxDownload4 } from '../../../../Functions/utils';


export default function ExportScenarios({apiRef, loading, model, setModel}) {
  const { t } = useTranslation();


  const excelDownload = () => {
    setModel(
      {...model, filtered: Array.from(apiRef.current.getVisibleRowModels().values())},
      () => {
        const date = getDeploymentDateTime();
        const fileDate = date.year + date.month + date.day + '-' + date.time.split(':').join('');

        const options = {
          delimiter: '`'
        };
        const csv = apiRef.current.getDataAsCsv(options);
        xlsxDownload4({
          csv: csv,
          filename: t('admin.scenarios.export.filename', {date: fileDate })
        });  
      }
    )
  };
  
  const pdfDownload = () => {
    setModel(
      {...model, filtered: Array.from(apiRef.current.getVisibleRowModels().values())},
      () => {
        const date = getDeploymentDateTime();
        const fileDate = date.year + date.month + date.day + '-' + date.time.split(':').join('');
        const fileName = t('admin.scenarios.export.filename', {date: fileDate });
  
        const table = document.getElementById('print');
  
        let doc = new jsPDF('p', 'pt', 'A4');
        doc.html(table, {
          margin: 20,
          elementHandlers: () => true,
          html2canvas: html2canvas(table),
          callback: (doc) => doc.save(fileName + '.pdf')
        });
      }
    )
  };


  return (
    <>
      <button
        disabled={loading}
        onClick={excelDownload}
        className="button icon"
        title={t('global.actions.xlsx')}
      >
        <span className="material-icons-round">table_view</span>
      </button>

      <button style={{display: 'none'}}
        disabled={loading}
        onClick={pdfDownload}
        className="button icon"
        title={t('global.actions.pdf')}
      >
        <span className="material-icons-round" style={{fontSize: '28px'}}>picture_as_pdf</span>
      </button>
    </>
  );
}
